<template>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            :label="label"
            :prepend-icon="iconStyle === 'outer' ? 'event': null"
            :prepend-inner-icon="iconStyle === 'inner' ? 'event': null"
            @click:prepend="menu=!menu"
            @click:prepend-inner="menu=!menu"
            readonly
            v-bind="attrs"
            v-on="on"
            :background-color="backgroundColor"
            :error-messages="errorMessages"  
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          no-title
          scrollable
          @change="datePicked"
          :allowed-dates="allowedDates"
          :rules="rules"
        >
 
        </v-date-picker>
      </v-menu>

</template>

<script>
export default {
    name: 'datePicker',
    components: {
    },
    props: {
      label: {
          type: String,
          default: 'Date'
      },
      value: {
        type: String,
        default: null
      },
      allowedDates: {
        type: Function,
        default: null
      },
      backgroundColor: {
          default: 'white',
          type: String
      },      
      iconColor: {
        default: null,
        type: String
      },      
      iconStyle: {
        default: 'outer',
        type: String
      },
      rules: {
          type: Array,
          default: () => []
      },   
      errorMessages: {
          type: Array,
          default: () => []
      },              

    },
    data: () => ({
        menu: false,
        date: null
    }),
    mounted() {
      this.date = this.value
    },
    methods: {
      datePicked(props) {
        this.menu = false
      }
    },
    computed: {
    },
    watch: {
        date (newValue, oldValue) {
          this.$emit('input', newValue)
          this.$emit('changed', newValue)
        }
    }
}
</script>
